module.exports = __webpack_public_path__ + "img/F112.2068a120.jpg";